<label class="input_label font_size_sm">{{ titleLabel }}</label>

<div [style.height.px]="imagePreviewHeight" [style.width.px]="imagePreviewWidth" (click)="!readonly && careplanImg.click()" [hidden]="cropperReady" class="icon_upload_container">
  <input #careplanImg type="file" (change)="onFileChanged($event)" [hidden]="true" [readOnly]="readonly" />

  <img *ngIf="selectedImage; else noIcon" [src]="selectedImage" alt="Preview Icon" class="preview_img" />
  <ng-template #noIcon>
    <img [src]="defaultImgUrl" alt="No Icon" class="icon_dflt" />
  </ng-template>
  <div class="img_label font_size_md" [hidden]="selectedImage">{{ uploadImageLabel }}</div>
</div>

<div class="uploader-wrapper">
  <image-cropper
    (imageCropped)="imageCroppedBase64($event)"
    (imageLoaded)="cropperReady = true"
    (loadImageFailed)="loadImageFailed()"
    [aspectRatio]="1"
    [imageChangedEvent]="imageChangedEvent"
    [style.display]="cropperReady ? null : 'none'"
    format="png"
    style="max-height: 33vh;"
  ></image-cropper>
</div>

<div class="icon_btn_container" *ngIf="!readonly">
  <div (click)="removeImg()" *ngIf="cropperReady || (!hideRemove && selectedImage)" class="icon_img_btn cancel_btn">
    <div>{{ 'COMMON.REMOVE'|translate }}</div>
  </div>

  <div class="icon_img_btn save_img_btn" *ngIf="cropperReady" (click)="saveImg()">
    <div>{{ 'COMMON.SAVE'|translate }}</div>
  </div>
</div>
